// Serviço de gerenciamento de tema
class ThemeService {
  constructor() {
    this.THEME_KEY = 'summdash_theme';
    this.currentTheme = this.loadTheme();
    this.listeners = new Set();
    this.applyTheme();
  }

  loadTheme() {
    const savedTheme = localStorage.getItem(this.THEME_KEY);
    return savedTheme || 'dark';
  }

  saveTheme(theme) {
    localStorage.setItem(this.THEME_KEY, theme);
  }

  applyTheme() {
    document.documentElement.setAttribute('data-theme', this.currentTheme);
    
    // Também adiciona classe para compatibilidade
    document.documentElement.classList.remove('light-theme', 'dark-theme');
    document.documentElement.classList.add(`${this.currentTheme}-theme`);
  }

  getTheme() {
    return this.currentTheme;
  }

  setTheme(theme) {
    if (theme !== 'light' && theme !== 'dark') return;
    
    this.currentTheme = theme;
    this.saveTheme(theme);
    this.applyTheme();
    this.notifyListeners();
  }

  toggleTheme() {
    const newTheme = this.currentTheme === 'light' ? 'dark' : 'light';
    this.setTheme(newTheme);
  }

  subscribe(callback) {
    this.listeners.add(callback);
    return () => this.listeners.delete(callback);
  }

  notifyListeners() {
    this.listeners.forEach(callback => callback(this.currentTheme));
  }
}

// Exporta instância única
export const themeService = new ThemeService();